<template>
  <div class="ReportIntegrationReseller">
    <HeaderPage>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBox
          v-on:filterExport="exportDados"
      />
      
    </el-card>
  </div>
</template>

<script>
import HeaderPage from '@/app/components/HeaderPage'
import FilterBox from '@/app/domains/Report/components/IntegrationReseller/_filterBox'
import { getIntegrationReseller } from '@/app/domains/Report/services';
import moment from "moment";

export default {
  name: "ReportIntegrationReseller",
  components: {
    HeaderPage,
    FilterBox,
  },
  data () {
    return {
      loadingPage: false,
      listData: {}
    }
  },
  methods: {
    openUrl(linkDownload){
      const title = `integrationReseller-${moment().format("YYYYMMDDHHmmss")}.json`;
      const url = window.URL.createObjectURL(new Blob([linkDownload]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    async exportDados(query = '') {
      this.loadingPage = true
      try {
        let response = await getIntegrationReseller(query)
        this.openUrl(response.data)

      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: 'error',
        })
      } finally {
        this.loadingPage = false
      }
    },
  },
}
</script>

<style scoped></style>
